import styled from 'styled-components';

export const ButtonContainer = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: ${ (props) => props.justifyContent };
  gap: ${ (props) => props.gap };
  align-items: ${ (props) => props.alignItems };
  align-self: ${ (props) => props.alignSelf };
  background-image: none;
  text-decoration: none;
  outline: none;
  z-index: ${ (props) => props.zIndex };
  flex: ${ (props) => props.flex };
  padding: ${ (props) => props.padding };
  margin: ${ (props) => props.margin };
  max-width: ${ (props) => props.maxWidth };
  width: ${ (props) => props.width };
  height: ${ (props) => props.height };
  background: ${ (props) => props.background };
  background-color: ${ (props) => props.backgroundColor };
  border-radius: ${ (props) => props.borderRadius };
  font-size: ${ (props) => props.fontSize }; 
  font-weight: ${ (props) => props.fontWeight };
  color: ${ (props) => props.color };
  margin: ${ (props) => props.margin };
  border: ${ (props) => props.border };

  :focus {
    outline: none;
  }
`;
